import { ArrowUpRight, Github, Linkedin, Mail } from 'lucide-react';
import SectionHeading from './SectionHeading';
import { useInView } from '../hooks/useInView';
import { profile } from '../data/resume';

export default function Contact() {
  const [ref, isVisible] = useInView();

  return (
    <section id="contact" className="section section--contact" ref={ref}>
      <div className={`reveal ${isVisible ? 'reveal--visible' : ''}`}>
        <SectionHeading number="05" title="Contact" />

        <div className="contact-block">
          <p className="contact-lead">
            Interested in full stack engineering roles where I can build products end to end —
            from user-facing interfaces to backend services and cloud infrastructure.
          </p>

          <a href={`mailto:${profile.email}`} className="contact-email">
            {profile.email}
            <ArrowUpRight size={22} strokeWidth={2} />
          </a>

          <div className="contact-links">
            <a href={profile.links.github} target="_blank" rel="noopener noreferrer" className="contact-link">
              <Github size={18} strokeWidth={1.75} />
              github.com/codingmaven1
            </a>
            <a href={profile.links.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link">
              <Linkedin size={18} strokeWidth={1.75} />
              linkedin.com/in/naman019
            </a>
            <a href={`mailto:${profile.email}`} className="contact-link">
              <Mail size={18} strokeWidth={1.75} />
              Send an email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
